import classNames from 'classnames';
import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './EditableCell.css';

export interface EditableCellProps {
    onClick: () => void;
    children: ReactNode;
    isActive: boolean;
    cls?: string;
}

export const EditableCell = React.memo(
    ({ onClick, children, isActive, cls }: EditableCellProps) => (
        <span
            onClick={onClick}
            className={classNames(
                cls,
                Bem.cls({
                    block: 'editable-cell',
                    elem: 'block',
                    mods: {
                        active: isActive
                    }
                })
            )}
        >
            {children}
            <Shape2
                icon={Shape2Icon.edit}
                width={12}
                height={12}
                theme={Shape2Theme.light}
                cls={Bem.cls('editable-cell', 'icon')}
            />
        </span>
    )
);
